import { render, staticRenderFns } from "./IosDevelopment.vue?vue&type=template&id=4280ed1a&"
import script from "./IosDevelopment.vue?vue&type=script&lang=js&"
export * from "./IosDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports